var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "url(#paint0_linear_265_1913)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3164 20.3906C25.4531 20.4727 25.5078 20.6367 25.4805 20.7734C25.1523 21.7578 24.6602 22.6328 23.9766 23.3711C23.8672 23.4805 23.7031 23.5078 23.5664 23.4258L22.3906 22.7695C21.8984 23.1797 21.3516 23.5078 20.75 23.7266V25.0664C20.75 25.2031 20.6406 25.3398 20.4766 25.3945C19.5195 25.5859 18.5078 25.6133 17.4961 25.3945C17.3594 25.3398 17.25 25.2031 17.25 25.0664V23.7266C16.6211 23.5078 16.0742 23.1797 15.582 22.7695L14.4062 23.4258C14.2695 23.5078 14.1055 23.4805 13.9961 23.3711C13.3398 22.6328 12.8203 21.7578 12.5195 20.7734C12.4648 20.6367 12.5195 20.4727 12.6562 20.3906L13.832 19.7344C13.7227 19.0781 13.7227 18.4492 13.832 17.793L12.6562 17.1367C12.5195 17.0547 12.4648 16.8906 12.5195 16.7539C12.8203 15.7695 13.3398 14.8945 13.9961 14.1562C14.1055 14.0469 14.2695 14.0195 14.4062 14.1016L15.582 14.7852C16.0742 14.3477 16.6211 14.0195 17.25 13.8008V12.4609C17.25 12.3242 17.332 12.1875 17.4961 12.1602C18.4531 11.9414 19.4648 11.9141 20.4766 12.1602C20.6406 12.1875 20.75 12.3242 20.75 12.4609V13.8008C21.3516 14.0195 21.8984 14.3477 22.3906 14.7578L23.5664 14.1016C23.7031 14.0195 23.8672 14.0469 23.9766 14.1562C24.6328 14.8945 25.1523 15.7695 25.4531 16.7539C25.5078 16.8906 25.4531 17.0547 25.3164 17.1367L24.1406 17.793C24.2773 18.4492 24.2773 19.0781 24.1406 19.7344L25.3164 20.3906ZM19 20.9375C20.2031 20.9375 21.1875 19.9805 21.1875 18.75C21.1875 17.5469 20.2031 16.5625 19 16.5625C17.7695 16.5625 16.8125 17.5469 16.8125 18.75C16.8125 19.9805 17.7695 20.9375 19 20.9375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_1913",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E96FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C9FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5876fb544fcb82780e269f01df724447.svg";
export { ForwardRef as ReactComponent };